'use client';

import { ArrowUpFromDot } from 'lucide-react';

export default function MoveToTopButton() {
    const moveToTop = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button type="button" aria-label="Move to top" onClick={moveToTop}>
            <ArrowUpFromDot
                strokeWidth={1.5}
                width={36}
                height={36}
                className="absolute bottom-[110px] right-[60px] max-lg:right-4 max-lg:bottom-[30px] text-white cursor-pointer hover:text-brand transition-colors duration-300 ease-in-out"
            />
        </button>
    );
}
